export default __webpack_public_path__ + "static/media/ButtonBackground.211345a8.webp";